import { useSyncExternalStore } from 'react';

/**
 * The computer's side panels (Gary, 18 Oct): the chat list and Info can each be hidden so a chat has the full
 * width. Kept on this computer only.
 */
export interface Panels { list: boolean; info: boolean }

const KEY = 'chats.panels';
let panels: Panels = read();
const listeners = new Set<() => void>();

function read(): Panels {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) ?? '{}') as Partial<Panels>;
    return { list: saved.list !== false, info: saved.info !== false };
  } catch {
    return { list: true, info: true };
  }
}

export function setPanel(which: keyof Panels, shown: boolean) {
  panels = { ...panels, [which]: shown };
  try { localStorage.setItem(KEY, JSON.stringify(panels)); } catch { /* storage blocked: this visit only */ }
  for (const l of listeners) l();
}

export function usePanels(): Panels {
  return useSyncExternalStore((l) => { listeners.add(l); return () => listeners.delete(l); }, () => panels);
}
